<template>
  <kd-popup class="recive-success-popup" :visible.sync="show" position="center" :hide-title="true">
    <template #default>
      <div class="main">
        <div class="title">提示</div>
        <div class="content">是否关闭AI体育老师分身</div>
        <div class="buttons">
          <button class="cancel-button" @click="close">取消</button>
          <button class="ok-button" @click="submit">确认关闭</button>
        </div>
      </div>
    </template>
  </kd-popup>
</template>

<script lang="ts">
import { KdPopup, KdButton } from 'kuaidong-ui'
// import * as drillService from '../services/DrillService'
import { BaseComponent, Component, Prop, PropSync } from 'kuaidong-component'

@Component({
  components: {
    KdPopup,
    KdButton,
  },
})
export default class CloseTipPopup extends BaseComponent {
  @PropSync('visible', { type: Boolean, default: false })
  show!: boolean

  close() {
    this.show = false
    this.$emit('close')
  }

  submit() {
    this.show = false
    this.$emit('submit')
  }
}
</script>

<style lang="less">
.kd-popup.recive-success-popup {
  > .kd-popup__main {
    border-radius: 16px;
    background: #fff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);

    > .kd-popup__content {
      padding: 25px 27px;
      > .main {
        width: 250px;
        > .title {
          color: #2d2f33;
          text-align: center;
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
        }

        > .content {
          line-height: 22px;
          margin: 10px 0 25px 0;
          color: #4d4d4d;
          text-align: center;
          font-size: 16px;
          font-weight: 400;
          > span {
            color: #3366ff;
          }
        }

        > .buttons {
          display: flex;
          justify-content: space-between;
          .cancel-button {
            border-radius: 22px;
            padding: 12px 27px;
            background: #f8f8f8;
            white-space: nowrap;
          }

          .ok-button {
            color: #fff;
            border-radius: 22px;
            background: #2364ea;
            padding: 12px 27px;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
</style>
